import React from "react";

interface SettingsRowProps {
  label: string;
  description: string;
  control: React.ReactNode;
  onClick?: () => void;
}

export const SettingsRow: React.FC<SettingsRowProps> = ({
  label,
  description,
  control,
  onClick,
}) => {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      onClick={onClick}
      className={`flex justify-between items-center${onClick ? " cursor-pointer bg-transparent border-0 p-0 text-left" : ""}`}
    >
      <div className="flex flex-col gap-0.5">
        <label className={`text-fg-medium${onClick ? " cursor-pointer" : ""}`}>
          {label}
        </label>
        <span className="text-fg-muted-regular">{description}</span>
      </div>
      {control}
    </Tag>
  );
};
